// zh.js
export default {
  lang: {
    // 会员码页面
    home: '首页',
    normalMember: '普通会员',
    vipMember: 'VIP会员',
    superVip: 'Super VIP会员',
    deluxeClue: 'Deluxe Clue会员',
    earnedPoints: '所得积分',
    membershipCode: '会员码',
    expire: '到期',
    accumulatedConsumption: '累积消费',
    spending: '再消费',
    todaySpending: '或当日消费满',
    upgradeLevel: '可升至',
    stayLevel: '可保级',
    yuan: '元',

    // 积分页面
    pointsFlow: '积分流水',
    availableIntegral: '可用积分',
    pointDetail: '积分明细',
    ofwhich: '其中',
    points: '积分',
    will: '将在',
    expired: '过期',

    // 历史优惠券
    historicalCoupon: '历史优惠券',
    all: '全部',
    used: '已使用',
    alreadyExpired: '已过期',

    // 购物记录
    orderLists: '购物记录',
    originOrderCode: '原订单号',
    actualPayment: '实际付款',
    orderGoodsName: '订单商品名',
    pleaseEnterGoodsName: '请输入商品名',
    orderType: '订单类型',
    order: '购物单',
    specialOrder: '正负单',
    refundOrder: '退款单',
    orderDate: '下单日期',
    nearlyAMonth: '近1个月',
    nearlyThreeMonths: '近3个月',
    nearlySixMonths: '近6个月',
    startDate: '开始时间',
    endDate: '结束时间',
    orderSource: '订单来源',

    // 优惠券
    myCoupon: '我的优惠券',
    couponDetail: '优惠券详情',
    couponList: '优惠券列表',
    couponClaim: '领取优惠券',
    couponCode: '券Code',
    please: '请于',
    beforeUse: '前使用',
    usedFor: '可适用于',
    useInstructions: '券使用说明', 

    //按钮 
    ok: '确认',
    cancel: '取消',
    close: '关闭',
    reset: '重 置',
    query: '查 询',
    confirmedUse: '确认使用',
    claim: '立即领取',
    // 提示
    copySuccess: '复制成功',
    copyFail: '复制失败',
    noMore: '没有更多了',
    confirmUseMsg: '确定使用后，优惠券将不可退回，请确认是否现在使用？',
    useSuccessfully: '使用成功！',
    receiveSuccess: '领取成功！',
    // 标题
    tip: '提示',
    filter: '筛选',
    selectStartDate: '选择开始日期',
    selectEndDate: '选择结束日期',
    chinaOnline: '大陆网店',
    chinaOffline: '大陆分店',
    hongkongOnline: '港澳网店',
    hongKongOffline: '港澳分店',
    usePlatform: '指定优惠券可用的平台',
    
    // 沒用的
    coupons: '优惠券',
    couponHistory: '历史券',

  }
}
